import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTING_REFORMA_PENSIONES } from '@constants/url.constant';
import { ConoceMasReformaComponent } from './pages/conoce-mas-reforma/conoce-mas-reforma.component';
import { DetalleBeneficioComponent } from './pages/detalle-beneficio/detalle-beneficio.component';
import { ReformaPensionesHomeComponent } from './pages/reforma-pensiones-home/reforma-pensiones-home.component';

const routes: Routes = [
   {
        path: "",
        redirectTo: ROUTING_REFORMA_PENSIONES.BENEFICIOS_REFORMA_HOME,
        pathMatch: "full",
    },
    {
        path: ROUTING_REFORMA_PENSIONES.BENEFICIOS_REFORMA_HOME,
        component: ReformaPensionesHomeComponent,
    },
    {
        path: ROUTING_REFORMA_PENSIONES.DETALLE_BENEFICIO_REFORMA,
        component: DetalleBeneficioComponent,
    },
    {
        path: ROUTING_REFORMA_PENSIONES.DETALLE_CONOCE_MAS_REFORMA,
        component: ConoceMasReformaComponent,
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReformaPensionesRoutingModule { }
